<template>
	<div class="foot">
		<div class="foot_pad">
			<div class="foot_t">
				<div class="foott_pad flex f-w j-a">
					<ul class="foottp_d1">
						<li><span>常见问题</span></li>
						<li><a @click="toHelp(0)">商品退换</a></li>
					</ul>
					<ul class="foottp_d1">
						<li><span>商城信息</span></li>
						<li><a @click="toHelp(1)">联系我们</a></li>
					</ul>
					<ul class="foottp_d1">
						<li><span>配送方式</span></li>
						<li><a @click="toHelp(2)">货到付款</a></li>
						<li><a @click="toHelp(3)">上门自取</a></li>
						<li><a @click="toHelp(4)">第三方配送</a></li>
						<li><a @click="toHelp(5)">何时发货</a></li>
					</ul>
					<ul class="foottp_d1">
						<li><span>微信公众号</span></li>
						<li><img :src="require('~a/imgs/2.png')" /></li>
					</ul>
					<div class="foottp_d1 foottp_d2">
						<div><img :src="require('~a/imgs/3.png')" /><span>客服热线</span></div>
						<span>400-600-0404</span>
					</div>
				</div>
			</div>
			<div class="foot_b flex a-c j-c">
				<a href="https://beian.miit.gov.cn/" target="_blank">Copyright © 金华鑫扬网络 All Rights Reserved 版权  备案号：浙ICP备16044921号-1</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'; 
	export default {
		data() {
			return {
				msg: "111",
			}
		},
		computed: {
			...mapState(['selectIndex']),
		},
		watch: {

		},
		created: function() {

		},
		mounted: function() {

		},
		methods: {
			toHelp(index) {
				this.$store.commit('updateSelectIndex', index);
				// console.log(this.selectIndex);
				this.$router.replace({
					path: '/help',
					query: {
						index: index
					}
				});
			}
		}
	}
</script>

<style scoped >
    .foot_pad{
	width: 100%;
	min-height: 268px;
}

.foot_t{
	width: 100%;
	min-height: 206px;
	background-color: black;
	margin: 0 auto;
}

.foot_b{
	height: 62px;
	font-size: 14px;
	color: #999999;
	text-align: center;
}

.foott_pad{
	width: 100%;
	margin: 0 auto;
	padding-top: 36px;
	color: #fff;
}



.foottp_d1{
	width: 140px;
	height: 170px;
	list-style-type:none;
}

.foottp_d1 span{
	font-size:18px;
	
}

.foottp_d1 li{
	padding-bottom: 6px;
	font-size: 12px;
}

.foottp_d1 li:nth-child(1){
	padding-bottom: 10px;
}

.foottp_d1 img{
	width: 99px;
	height: 99px;
}

.foottp_d2{
	float: right;
}

.foottp_d2 div{
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 15px;
}

.foottp_d2 img{
	width: 24px;
	height: 24px;
	margin-right:10px;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>